(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-furniture-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const selector = event.target;
  if (!(selector instanceof HTMLSelectElement) || !selector.matches('[data-bb-furniture-variant]')) return;
  const option = selector.selectedOptions[0];
  const form = selector.closest('.bb-furniture-form');
  if (!option || !form) return;
  const available = option.dataset.available === 'true';
  const button = form.querySelector('[name="add"]');
  button.disabled = !available;
  button.querySelector('[data-add-label]').textContent = available ? button.dataset.addText : button.dataset.unavailableText;
  const price = form.closest('.bb-purchase').querySelector('[data-price]');
  if (price) price.textContent = option.dataset.price;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-info-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-info-page')) {
  customElements.define('bb-info-page', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.buildNavigation(), { once: true });
      } else {
        this.buildNavigation();
      }
    }
    buildNavigation() {
      if (!this.isConnected || this.dataset.navigationReady === 'true') return;
      const documentBody = this.querySelector('[data-bb-info-document]');
      const navigation = this.querySelector('[data-bb-info-toc]');
      const list = this.querySelector('[data-bb-info-links]');
      if (!documentBody || !navigation || !list) return;
      let headings = Array.from(documentBody.querySelectorAll('h2'));
      if (!headings.length) headings = Array.from(documentBody.querySelectorAll('h3'));
      const fragment = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        const label = heading.textContent.trim();
        if (!label) return;
        if (!heading.id) heading.id = `${this.id}-section-${index + 1}`;
        if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = label;
        item.append(link);
        fragment.append(item);
      });
      list.replaceChildren(fragment);
      navigation.hidden = !list.children.length;
      this.dataset.navigationReady = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-cart-properties')) {
    customElements.define('bb-cart-properties', class extends HTMLElement {
      connectedCallback() {
        this.observer = new MutationObserver(() => this.formatFabric());
        this.observer.observe(this, { childList: true, subtree: true, characterData: true });
        this.formatFabric();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      formatFabric() {
        this.querySelectorAll('.cart-items__property').forEach((property) => {
          const label = property.querySelector('dt');
          const value = property.querySelector('dd');
          if (label?.textContent.trim() !== 'Product options:' || !value) return;
          const raw = value.textContent.trim();
          let options;
          try {
            options = JSON.parse(raw.startsWith('{') ? raw : `{${raw}}`);
          } catch {
            return;
          }
          if (!options || Array.isArray(options) || Object.keys(options).length !== 1) return;
          if (!Array.isArray(options.Fabric) || options.Fabric.length !== 1) return;
          const fabric = options.Fabric[0];
          if (typeof fabric !== 'string' || !fabric.trim()) return;
          label.textContent = 'Fabric:';
          value.textContent = fabric;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
